import onReady from '../utils/onReady';
import $ from 'jquery';
import 'slick-carousel/slick/slick';

/**
 * Boilerplate class demonstrating basic construction.
 * You can expand from here, or find verbose examples in example.js.
 *
 * @param {HTMLElement} container
 * @constructor
 */
class HorizontalSliderVariableWidth {

    /**
     * The constructor is fired once the class is instantiated.
     *
     * @param {HTMLElement} container
     */
    constructor(container) {
        // Run initializing code once the DOM is ready.
        onReady(() => this.init(container));

        // You can put other initializer-code here if it isn't dependent on the DOM in any way.
    }


    /**
     * The actual initialization function, fired once the DOM is ready.
     *
     * @param {HTMLElement} container
     */
    init(container) {

        this.dom = {
            container // ES6 allows this syntax instead of writing "container: container"
        };

        const sliderElement = this.dom.container;

        $(sliderElement).slick({
            infinite: false,
            speed: 300,
            //slidesToShow: 3,
            adaptiveHeight:false,
            variableWidth: true,
            slidesToScroll: 1,
            prevArrow: $('.slider-prev'),
            nextArrow: $('.slider-next'),
        });
    }

}


export default HorizontalSliderVariableWidth;